import { FC } from 'react';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

import styles from './matter-news.module.css';
import { ShareNews } from './share-news';

export interface IMatterNewsProps {
  category: string;
  image: string;
  date: string;
  authorRead: string;
  authorPicture: string;
  newsContent: string;
}

export const MatterNews: FC<IMatterNewsProps> = ({
  category,
  image,
  date,
  newsContent,
}) => {
  return (
    <div className={styles.containerContent}>
      <div className={styles.containerNewsWrapper}>
        <div className={styles.containerNews}>
          <div className={styles.containerImageBox}>
            <img src={image} alt="Imagem da matéria" />
          </div>

          <div className={styles.containerTextBox}>
            <div
              dangerouslySetInnerHTML={{
                __html: newsContent,
              }}
            />
          </div>
        </div>

        
      </div>

      <div className={styles.detailsCard}>
        <h3 className={styles.detailsTitle}>Detalhes da Notícia</h3>
        <div className={styles.detailsList}>
          <div className={styles.detailsItem}>
            <div className={styles.detailsIcon}>
              <AccountBalanceIcon />
            </div>
            <div className={styles.detailsText}>{category}</div>
          </div>
          <div className={styles.detailsItem}>
            <div className={styles.detailsIcon}>
              <CalendarTodayIcon />
            </div>
            <div className={styles.detailsText}>{date}</div>
          </div>
          <div className={styles.shareWrapper}>
            <ShareNews />
          </div>
        </div>
      </div>
    </div>
  );
};